export default __webpack_public_path__ + "static/media/engrace4.c278f317.webp";